import { IAttrValue } from "@multiweb/types/contracts";
import { AttrValueReader } from "../../../../OW.Remoting/Remoting/AttrValueReader";
import { OWDocumentDescription } from "../../../../OW.Remoting/Remoting/DataTypes/OWDocumentDescription";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { FileEditTemplate } from "../Templates/DataTypeEditTemplates/FileEditTemplate";
import { FileTemplate } from "../Templates/DataTypeTemplates/FileTemplate";
import { Column } from "./Column";

export class FileColumn extends Column {
    //#region Fields
    //#endregion

    //#region Methods

    public override async formatValue(data: IAttrValue | IAttrValue[]): Promise<string> {
        if (data instanceof Array) {
            if (data.length > 0)
                data = data[0];
            else
                return "";
        }

        const val = AttrValueReader.read(data);
        if (val == null || val === "")
            return "";

        if (val instanceof OWDocumentDescription)
            return await val.getName();

        if (typeof val === "string") {
            const lastColon = val.lastIndexOf(":");
            return lastColon !== -1 ? val.substr(lastColon + 1) : val;
        }

        return val;
    }

    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.itemTemplate = new FileTemplate();
        this.editItemTemplate = new FileEditTemplate();
    }
    //#endregion HTMLElement

    public override dispose(): void {
        super.dispose();
    }
} //end Column

registerCustomElement("tsc-FileColumn", FileColumn);
